import React from 'react';
import {
  AccountOutlined,
  BoxOutlined,
  LocationOutlined,
  UnionPaymentOutlined,
  MarkAsReadAlternativeOutlined,
  NewsOutlined,
  NotificationsOutlined,
  OrderOutlined,
  PhoneOutlined,
} from '@teko/ds-icon';
import { NavItem } from 'types';

const NAV_ITEMS: NavItem[] = [
  {
    icon: <AccountOutlined size={18} />,
    text: 'Thông tin tài khoản',
    href: '/account',
    contentName: 'viewAccountInfo',
    regionName: 'headerBar',
  },
  {
    icon: <OrderOutlined size={18} />,
    text: 'Quản lý đơn hàng',
    href: '/account/orders',
    contentName: 'viewOrder',
    regionName: 'headerBar',
  },
  {
    icon: <LocationOutlined size={18} />,
    text: 'Sổ địa chỉ',
    href: '/account/addresses',
    contentName: 'viewAddressList',
    regionName: 'headerBar',
  },
  {
    icon: <NotificationsOutlined size={18} className="noti" />,
    text: 'Thông báo',
    href: '/notification',
    anonymous: true,
    showByConfiguration: true,
    contentName: 'viewNotification',
    regionName: 'headerBar',
  },
  {
    icon: <UnionPaymentOutlined size={18} />,
    text: 'Điểm thành viên',
    href: '/my/loyalty-history',
    contentName: 'viewLoyalty',
    regionName: 'headerBar',
  },
  {
    icon: <NewsOutlined size={18} />,
    text: 'Bản tin',
    href: '/account/notifications',
    contentName: 'viewNotifications',
    regionName: 'headerBar',
  },
  {
    icon: <BoxOutlined size={18} />,
    text: 'Tồn kho và xuất bán',
    href: '/account/sellout',
    contentName: 'viewSellout',
    regionName: 'headerBar',
  },
  {
    icon: <MarkAsReadAlternativeOutlined size={18} />,
    text: 'Danh sách báo cáo',
    href: '/account/reports',
    contentName: 'viewReports',
    regionName: 'headerBar',
  },
  {
    icon: <PhoneOutlined size={18} />,
    text: 'Liên hệ Masan',
    href: '/customer-care',
    contentName: 'viewFeedback',
    regionName: 'headerBar',
  },
];

export const SHARED_NAV_ITEMS = NAV_ITEMS.slice(0, 5);

export const PV_NAV_ITEMS = NAV_ITEMS.slice(0, 6);

export const MASAN_DEALER_NAV_ITEMS = [
  ...NAV_ITEMS.slice(0, 4),
  ...NAV_ITEMS.slice(6, 8),
];
